module.exports = __webpack_public_path__ + "img/logo.ada87ff0.png";